import { render } from "./Fullstack.vue?vue&type=template&id=c2c74954&scoped=true"
import script from "./Fullstack.vue?vue&type=script&lang=js"
export * from "./Fullstack.vue?vue&type=script&lang=js"

import "./Fullstack.vue?vue&type=style&index=0&id=c2c74954&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Tenisu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2c74954"]])

export default __exports__